import React from 'react';
import ConfirmationDialog from '../../ConfirmationDialog';
import ApprovalDialogBody from '../ApprovalDialogBody';

const DenyDialog = ({ msg, onClose, onAccept, ...props }) =>
    <ConfirmationDialog
        {...props}
        onClose = { onClose }
        cancelButton={{
            action: onClose,
            label: 'NO, CANCEL'
        }}
        acceptButton={{
            action: onAccept,
            label: 'YES, DENY'
        }}
        header="Do you confirm that  you Deny this Exception?"
        body={<ApprovalDialogBody msg={msg} />}
    />;

export default DenyDialog;